import { FunctionComponent } from "preact";

import * as dateish from "@/dateish";
import * as db from "@/db";
import { AppState } from "@/appstate";
import { dayOfYearSpecies, monthOfYearSpecies, speciesDayOfYear, speciesStreaks, streakDays } from "@/ebird/agg";

import { CalendarYearless } from "@/ui/calendar";
import DataTable from "@/ui/data_table";
import TaxonLink from "@/ui/taxon_link";
import { Observation } from "@/ebird/ebird";
import { LinkDoY, LinkMoY } from "@/ui/date_link";

export const BirdTable: FunctionComponent<{
  taxonomy: db.TaxonomyDB, allObservations: Observation[]
}> = ({ taxonomy, allObservations }) => {
  const countable = allObservations.filter(o => o.taxon.speciesCode);
  const byStreaks = speciesStreaks(countable);
  const byDoY = speciesDayOfYear(countable);

  const rows = byStreaks.map(([spcode, streaks]) => {
      const bestStreak = streaks[0];
      const taxon = taxonomy.code(bestStreak[0].taxon.speciesCode!); // TODO: speciesTaxon property - differentiate speciesCode and ID from taxon
      return { taxon, bestStreak, doyMap: byDoY.get(spcode)! };
    })
    .sort((a, b) => b.doyMap.size - a.doyMap.size)
    // .sort((a, b) => streakDays(b.bestStreak) - streakDays(a.bestStreak))
    .map((r, i) => {
      const start = r.bestStreak[0], [end] = r.bestStreak.slice(-1);
      const streak = `${streakDays(r.bestStreak)} (${dateish.yearMonDay(start.date)} => ${dateish.yearMonDay(end.date)})`;
      return [
        i+1,
        <TaxonLink taxon={r.taxon} />,
        r.doyMap.size,
        streak
      ];
    });

  return <DataTable klass='birding-agg' header={['#', 'Bird', 'Days of Year', 'Best Streak']} rows={rows} />;
}

const HomePage: FunctionComponent<AppState> = (props) => {
  const { allObservations, theme, store} = props;

  const daily = dayOfYearSpecies(allObservations);
  const monthly = monthOfYearSpecies(allObservations);

  const count = (doy: dateish.DoY) => daily.get(doy)?.size ?? 0;
  const dcell = (doy: dateish.DoY) => {
    return <LinkDoY class='count' doy={doy}>{ count(doy) }</LinkDoY>;
  }
  const dstyle = (doy: dateish.DoY) => {
    const c = count(doy);
    return c > 0 ? { backgroundColor: theme.dayColor.value(c) } : {};
  }
  const mcell = (moy: dateish.MoY) => {
    // TODO: Make the month name clickable and include it too?
    return <LinkMoY class='month-count' moy={moy}>({ monthly.get(moy)?.size })</LinkMoY>;
  }

  return <div class='home content'>
    <CalendarYearless cells={{ doy: dcell, moy: mcell }} styles={{ doy: dstyle }} />
    <BirdTable taxonomy={ store.taxonomy } allObservations={ allObservations } />
  </div>
}

export default HomePage;
